import { localStorageGetMap, localStorageStoreIterable } from ".";


type RecentCameras = Map<number, number>;

const KEY_RECENT_CAMERAS = "recentStreamCameras";

export const getRecentCameras = (): RecentCameras => localStorageGetMap(KEY_RECENT_CAMERAS);

export const getRecentCamera = (liveUnitId: number): null | number => {
    const recentCameras = getRecentCameras();

    return recentCameras.get(liveUnitId) ?? null;
};

export const storeRecentCamera = (liveUnitId: number, cameraId: number): void => {
    const recentCameras = getRecentCameras();

    recentCameras.delete(liveUnitId);
    recentCameras.set(liveUnitId, cameraId);

    localStorageStoreIterable(KEY_RECENT_CAMERAS, recentCameras, { maxEntries: 20 });
};
